import classNames from 'classnames';
import React from 'react';
import CLButton, {CLButtonProps} from '../CLButton/CLButton';
import './CLDropDownButton.scss';
import CLMenuArrow from '../CLMenuArrow/CLMenuArrow';

export interface CLDropDownButtonProps extends CLButtonProps {
  width?: number;
  isOpen: boolean;
  buttonClassName?: string;
  arrowClassName?: string;
}

function CLDropDownButton({
  width,
  isOpen,
  className,
  buttonClassName = '',
  arrowClassName = '',
  buttonType = 'primary',
  qaHook = '',
  ...args
}: CLDropDownButtonProps) {
  const style = {
    width: width ? `${width}px` : '100%',
  };

  return (
    <div className="cl_dropdown_button">
      <div style={style} className={classNames('dropdown_button', className)}>
        <CLMenuArrow
          startPosition={isOpen ? 'up' : 'down'}
          className={classNames('drop_down_Arrow', buttonType, arrowClassName)}
        />
        <CLButton
          qaHook={qaHook}
          buttonType={buttonType}
          className={buttonClassName}
          style={{
            textAlign: 'left',
            minWidth: 'unset',
            paddingLeft: 'var(--cl_space_2)',
            paddingRight: 'var(--right_side_spacing)',
          }}
          {...args}
        />
      </div>
    </div>
  );
}

export default CLDropDownButton;
